function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HeardAndMcDonaldIslandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#2E42A5",
      fillRule: "evenodd",
      d: "M0 3h24v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "14",
      height: "11",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 3h13.5v10.5H0z"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        d: "m-1.503 12.75 2.97 1.303 12.1-9.636 1.567-1.937-3.176-.435-4.936 4.152L3.05 8.995l-4.553 3.755Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F50100",
        d: "m-1.097 13.663 1.514.756L14.572 2.3h-2.125L-1.096 13.663Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        d: "m15.003 12.75-2.97 1.303-12.1-9.636-1.567-1.937 3.176-.435 4.936 4.152 3.972 2.798 4.553 3.755Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F50100",
        d: "m14.902 13.405-1.514.756-6.027-5.188-1.787-.58-7.36-5.906H.34l7.355 5.766 1.954.695 5.253 4.457Z"
      }), /*#__PURE__*/_jsxs("mask", {
        id: "c",
        width: "16",
        height: "13",
        x: "-1",
        y: "2",
        fill: "#000",
        maskUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M-1 2h16v13H-1z"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          d: "M7.488 3h-1.5v4.5H0V9h5.988v4.5h1.5V9H13.5V7.5H7.488V3Z",
          clipRule: "evenodd"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F50100",
        fillRule: "evenodd",
        d: "M7.488 3h-1.5v4.5H0V9h5.988v4.5h1.5V9H13.5V7.5H7.488V3Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#F7FCFF",
        d: "M5.988 3v-.75h-.75V3h.75Zm1.5 0h.75v-.75h-.75V3Zm-1.5 4.5v.75h.75V7.5h-.75ZM0 7.5v-.75h-.75v.75H0ZM0 9h-.75v.75H0V9Zm5.988 0h.75v-.75h-.75V9Zm0 4.5h-.75v.75h.75v-.75Zm1.5 0v.75h.75v-.75h-.75Zm0-4.5v-.75h-.75V9h.75ZM13.5 9v.75h.75V9h-.75Zm0-1.5h.75v-.75h-.75v.75Zm-6.012 0h-.75v.75h.75V7.5Zm-1.5-3.75h1.5v-1.5h-1.5v1.5Zm.75 3.75V3h-1.5v4.5h1.5ZM0 8.25h5.988v-1.5H0v1.5ZM.75 9V7.5h-1.5V9h1.5Zm5.238-.75H0v1.5h5.988v-1.5Zm.75 5.25V9h-1.5v4.5h1.5Zm.75-.75h-1.5v1.5h1.5v-1.5ZM6.738 9v4.5h1.5V9h-1.5Zm6.762-.75H7.488v1.5H13.5v-1.5Zm-.75-.75V9h1.5V7.5h-1.5Zm-5.262.75H13.5v-1.5H7.488v1.5ZM6.738 3v4.5h1.5V3h-1.5Z",
        mask: "url(#c)"
      })]
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      d: "m8.908 16.334-.59.546.058-.802-.795-.121.664-.455-.4-.697.768.236.295-.748.295.748.769-.236-.4.697.663.455-.795.121.058.802-.59-.546ZM15.276 12.569l-.394.364.04-.535-.53-.08.442-.303-.267-.465.512.157.197-.499.197.499.512-.157-.267.464.442.303-.53.081.04.535-.394-.364ZM16.215 8.877l-.394.363.04-.534-.53-.081.442-.303-.268-.465.513.157.197-.498.197.498.512-.157-.267.465.442.303-.53.08.04.535-.394-.363ZM18.561 10.723l-.393.364.039-.535-.53-.08.442-.304-.267-.464.512.157.197-.499.197.499.513-.157-.268.464.443.303-.53.081.039.535-.394-.364ZM16.684 16.03l-.394.364.04-.534-.53-.081.442-.303-.267-.465.512.157.197-.498.197.498.512-.157-.267.465.442.303-.53.08.04.535-.394-.363ZM18.327 13.148l-.4.21.076-.445-.323-.316.447-.064.2-.406.2.405.447.065-.324.316.077.445-.4-.21Z"
    })]
  })]
}));
//# sourceMappingURL=HeardAndMcDonaldIslands.js.map